import React, { SVGProps } from 'react'

export const EqualIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} fill="none" {...props}>
    <path fill="#000" fillOpacity={0.56} d="M15.833 9H4.167V7h11.666v2Zm0 5H4.167v-2h11.666v2Z" />
  </svg>
)
